import { createContext } from "react";
//#region src/components/Menu/MenuContext.tsx
/**
* A React context providing information about the menu in which a given
* component resides.
*/
var MenuContext = createContext(null);
//#endregion
export { MenuContext };

//# sourceMappingURL=MenuContext.js.map